var bannerScreenWidthCheck = 0;

function getData(el, name) {
    if (!el) return null;
    // convert hyphenated name to dataset camelCase
    var camel = name.indexOf('-') > -1 ? name.split('-').map(function (s, i) { return i === 0 ? s : s.charAt(0).toUpperCase() + s.slice(1); }).join('') : name;
    if (el.dataset && typeof el.dataset[camel] !== 'undefined') return el.dataset[camel];
    // fallback to attribute (name may already be hyphenated)
    var attr = el.getAttribute('data-' + name);
    if (attr !== null) return attr;
    // try attribute using camel to hyphen
    var hyphen = camel.replace(/([A-Z])/g, function (m) { return '-' + m.toLowerCase(); });
    return el.getAttribute('data-' + hyphen);
}

function empty(el) {
    while (el && el.firstChild) el.removeChild(el.firstChild);
}

function SetVideo() {
    var screenWidth = window.innerWidth;

    // Only do this if the screen width has checked since the last recorded size. The resize appears to be updating on scroll.
    if (bannerScreenWidthCheck != screenWidth) {

        bannerScreenWidthCheck = screenWidth;

        // if window width is smaller than 1024, assume mobile device. Using 1024 as mobile device screen resolution is quite large these days
        if (screenWidth < 1024) {
            var screenHeight = window.innerHeight;

            document.querySelectorAll('.video-autoplay, .banner-video-container').forEach(function (mainVideo) {

                var videoSrc = screenWidth < screenHeight ? 'video-src-mobile' : 'video-src-mobile-landscape';

                console.log(videoSrc);
                console.log(getData(mainVideo, videoSrc));

                if (getData(mainVideo, videoSrc)) {
                    document.querySelectorAll('.video-overlay').forEach(function (o) { o.style.display = ''; });

                    // empty the existing video from the container and switch off autoplay on mobile
                    empty(mainVideo);
                    mainVideo.removeAttribute('autoplay');
                    // add new video and load it
                    var source = document.createElement('source');
                    source.type = 'video/mp4';
                    source.src = getData(mainVideo, videoSrc);
                    mainVideo.appendChild(source);
                    try { mainVideo.src = getData(mainVideo, videoSrc); } catch (e) {}
                    try { if (typeof mainVideo.load === 'function') mainVideo.load(); } catch (e) {}

                    document.querySelectorAll('.video-overlay').forEach(function (o) { o.classList.remove('playing'); });
                }
                else {
                    document.querySelectorAll('.video-overlay').forEach(function (o) { o.style.display = 'none'; });
                    empty(mainVideo);
                    try { mainVideo.removeAttribute('src'); } catch (e) {}
                }
            });
        } else {
            document.querySelectorAll('.video-autoplay, .banner-video-container').forEach(function (mainVideo) {

                if (getData(mainVideo, 'video-src-desktop')) {
                    // empty existing video from the container
                    empty(mainVideo);

                    // add new video, set it to autoplay on desktop then load and play it to make sure it plays
                    var source = document.createElement('source');
                    source.type = 'video/mp4';
                    source.src = getData(mainVideo, 'video-src-desktop');
                    mainVideo.appendChild(source);
                    try { mainVideo.src = getData(mainVideo, 'video-src-desktop'); } catch (e) {}
                    mainVideo.setAttribute('autoplay', 'true');

                    try { if (typeof mainVideo.load === 'function') mainVideo.load(); } catch (e) {}
                    try { if (typeof mainVideo.play === 'function') mainVideo.play(); } catch (e) {}
                }
                else {
                    empty(mainVideo);
                    try { mainVideo.removeAttribute('src'); } catch (e) {}
                }
            });
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {

    SetVideo();

    // When the play video button is clicked.
    document.querySelectorAll('.video-overlay-click').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            if (window.innerWidth < 1024) {
                var parent = btn.parentElement && btn.parentElement.parentElement ? btn.parentElement.parentElement : null;
                if (parent) parent.classList.add('playing');

                var video = document.querySelectorAll('.video-autoplay, .banner-video-container');
                if (video && video[0] && typeof video[0].play === 'function') {
                    try { video[0].play(); } catch (ex) { /* ignore */ }
                }
            }
            e.stopPropagation();
        });
    });

    document.querySelectorAll('.video-overlay').forEach(function (ov) {
        ov.addEventListener('click', function (e) {
            if (window.innerWidth < 1024 && ov.classList.contains('playing')) {
                ov.classList.remove('playing');

                var video = document.querySelectorAll('.video-autoplay, .banner-video-container');
                if (video && video[0] && typeof video[0].pause === 'function') {
                    try { video[0].pause(); } catch (ex) { /* ignore */ }
                }
            }
        });
    });

    window.addEventListener('resize', function () {
        SetVideo();
    });
});


